<template>
  <div>
    <!-- <span class="basisInformation">学生管理</span> -->
    <!-- <el-divider></el-divider> -->

    <el-row :gutter="12">
      <el-col :span="24" class="col-header">
        <el-card shadow="never"> 学生管理</el-card>
      </el-col>
    </el-row>

    <!-- 头部功能区域 -->
    <el-form :inline="true" class="demo-form-inline" size="small">
      <el-form-item v-if="type == 8 ? false : true">
        <el-select
          placeholder="请选择"
          v-model="studentObj.gradeId"
          style="width: 120px"
          @change="(value) => changeclassesLists(value)"
        >
          <el-option label="全部年级" value=""></el-option>
          <el-option
            v-for="item in gradeList"
            :key="item.gradeId"
            :label="item.name"
            :value="item.gradeId"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item v-if="type == 8 ? false : true">
        <el-select
          placeholder="请选择班级"
          v-model="studentObj.classesId"
          :disabled="classesList.length > 0 ? false : true"
          style="width: 120px"
          clearable
        >
          <el-option
            v-for="item in classesList"
            :key="item.id"
            :label="item.title"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item v-if="type == 8 ? true : false">
        <el-select
          placeholder="请选择班级"
          v-model="studentObj.classesId"
          style="width: 120px"
          clearable
        >
          <el-option
            v-for="item in classesLists"
            :key="item.id"
            :label="item.title"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-select
          placeholder="请选择状态"
          v-model="studentObj.active"
          style="width: 120px"
          clearable
        >
          <el-option label="全部状态" value=""></el-option>
          <el-option label="已登录" value="1"></el-option>
          <el-option label="未登录" value="0"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-input
          style="width: 140px"
          maxlength="20"
          placeholder="请输入学生姓名"
          v-model.trim="studentObj.name"
        ></el-input>
      </el-form-item>
      <el-form-item v-if="type == 8 ? true : false">
        <el-input
          placeholder="请输入学员编号"
          maxlength="20"
          v-model.trim="studentObj.rosterNo"
        ></el-input>
      </el-form-item>
      <el-form-item v-else>
        <el-input
          placeholder="请输入学籍号"
          v-model.trim="studentObj.rosterNo"
        ></el-input>
      </el-form-item>
      <!-- 按手机号搜索 -->
      <el-form-item>
        <el-input
          style="width: 140px"
          maxlength="11"
          placeholder="请输入家长手机号"
          v-model.trim="studentObj.mobile"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="searchLists">搜 索</el-button>
      </el-form-item>
      <el-form-item v-if="authSource == 'system'">
        <add-student
          :gradeList="gradeList"
          :nationList="nationList"
          :relationList="relationList"
          @updateList="searchList"
        />
      </el-form-item>
      <el-form-item v-if="authSource == 'system'">
        <student-import
          :token="token"
          :schoolId="schoolId"
          :btnTxt="'批量导入'"
          @updateList="searchList"
        />
      </el-form-item>
      <el-form-item v-if="type == 8 ? false : true && authSource == 'system'">
        <student-import
          :token="token"
          :schoolId="schoolId"
          :btnTxt="'学生批量换班'"
          @updateList="searchList"
        />
      </el-form-item>
      <el-form-item v-if="type == 8 ? false : true && authSource == 'system'">
        <el-button size="small" type="primary" @click="RemoveParent"
          >解除家长绑定</el-button
        >
      </el-form-item>
      <el-form-item v-if="type == 8 ? false : true && authSource == 'system'">
        <student-transfer
          :schoolId="exportStudentObj.schoolId"
          :gradeList="gradeList"
          :nationList="nationList"
          :relationList="relationList"
          @updateList="searchList"
        />
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" @click="getApiExportStudentList"
          >导出家校通讯录</el-button
        >
      </el-form-item>
    </el-form>
    <!-- 表格区域 -->
    <el-table
      :row-style="{ height: '48px' }"
      :header-cell-style="{ background: '#f5f5f5', height: '48px' }"
      border
      stripe
      ref="studentTable"
      :data="studentTableList"
    >
      <!-- @selection-change="handleSelectionChange" -->
      <!-- <el-table-column
        v-if="type == 8 ? false : true"
        type="selection"
        align="center"
        :selectable="CheckSelecttable"
      /> -->
      <el-table-column
        v-if="type == 8 ? false : true"
        label="班级"
        align="center"
        width="120"
      >
        <template slot-scope="scope">
          {{
            scope.row.gradeClasses.gradeName + scope.row.gradeClasses.className
          }}
        </template>
      </el-table-column>
      <el-table-column v-else label="班级" align="center" width="120">
        <template slot-scope="scope">
          {{ scope.row.gradeClasses.className }}
        </template>
      </el-table-column>
      <el-table-column
        v-if="type == 8 ? false : true"
        label="学籍号"
        width="220"
        prop="student.rosterNo"
        align="center"
      >
      </el-table-column>
      <el-table-column
        v-else
        label="学员编号"
        width="220"
        prop="student.rosterNo"
        align="center"
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="student.name"
        label="学生姓名"
        width="150"
      >
      </el-table-column>
      <el-table-column align="center" label="家长">
        <template slot-scope="scope">
          <span v-if="scope.row.parentList && scope.row.parentList.length">
            <span
              style="margin-left: 4px"
              v-for="(item, index) in scope.row.parentList"
              :key="index"
              >{{ item.name }}</span
            >
          </span>
          <add-parent
            v-else
            :relationList="relationList"
            :studentId="scope.row.student.id"
            @updateList="searchList"
          />
        </template>
      </el-table-column>
      <!-- <el-table-column align="center" label="家长电话">
        <template slot-scope="scope">
          <span v-if="scope.row.parentList && scope.row.parentList.length">
            <span>{{ scope.row.parentList[0].mobile }}</span>
          </span>
        </template>
      </el-table-column> -->
      <el-table-column align="center" label="登录状态" width="150">
        <template slot-scope="scope">
          <span>{{ scope.row.student.active ? '已登录' : '未登录' }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        align="center"
        width="360"
        header-align="center"
      >
        <template slot-scope="scope">
          <!-- <el-button
            type="text"
            size="small"
            class="text_btn"
            @click="ApiResetPass('student', scope.row)"
            >重置学生密码</el-button
          >
          <el-button
            type="text"
            size="small"
            v-if="scope.row.parentList && scope.row.parentList.length"
            @click="ApiResetPass('parent', scope.row)"
            >重置家长密码</el-button
          > -->
          <update-parent
            :gradeList="gradeList"
            :nationList="nationList"
            :relationList="relationList"
            @updateList="searchList"
            :classes="scope.row.gradeClasses"
            :studentObj="scope.row.student"
            :parentList="scope.row.parentList"
          />
          <update-student
            v-if="authSource == 'system'"
            :gradeList="gradeList"
            :nationList="nationList"
            :relationList="relationList"
            @updateList="searchList"
            :classes="scope.row.gradeClasses"
            :studentObj="scope.row.student"
            :parentList="scope.row.parentList"
          />
          <!-- v-if="roleType == 'school'" -->
          <el-button
            v-if="authSource == 'system'"
            type="text"
            size="small"
            class="left_btn delete_btn"
            @click="DeleteStudentHandle(scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页区域 -->
    <el-pagination
      background
      layout="total,prev,pager,next,sizes"
      :total="studentObj.totalCount"
      :page-size="studentObj.pageSize"
      :page-sizes="[10, 20, 50, 100]"
      :current-page="studentObj.curPage"
      @current-change="currentChange"
      @size-change="handleSizeChange"
    ></el-pagination>
    <!-- 导出学生 -->
    <el-dialog
      :visible.sync="dialogVisible"
      :center="true"
      custom-class="el__dialog"
      :title="dialogAction"
      :destroy-on-close="true"
      width="30%"
    >
      <div
        class="exportstudent dialog__content"
        v-if="dialogAction == '导出家校通讯录'"
      >
        <el-form :model="exportStudentObj" ref="exportStudentObjForm">
          <el-form-item
            label="年级"
            prop="gradeId"
            required
            :rules="[{ required: true, message: '年级不能为空' }]"
          >
            <el-select
              v-model="exportStudentObj.gradeId"
              @change="(value) => changeclassesList(value)"
            >
              <el-option label="全部年级" value="-1"></el-option>
              <el-option
                v-for="item in gradeList"
                :key="item.gradeId"
                :label="item.name"
                :value="item.gradeId"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="班级" prop="classesId">
            <el-checkbox-group
              v-model="checkList"
              :disabled="exportStudentObj.gradeId == ''"
            >
              <el-checkbox
                v-for="item in classesLists"
                :key="item.id"
                :label="item.title"
                @change="checkBox(item.id, item.title)"
              ></el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item
            label="模板"
            prop="studentTemplateType"
            required
            :rules="[{ required: true, message: '模板不能为空' }]"
          >
            <el-radio-group v-model="exportStudentObj.studentTemplateType">
              <el-radio :label="1">模板A</el-radio>
              <el-radio :label="2">模板B</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
      </div>

      <footer class="dialog__footer" slot="footer">
        <el-row type="flex" justify="end">
          <el-button size="small" @click="hidedialogVisible">取消</el-button>
          <el-button
            v-if="dialogAction == '导出家校通讯录'"
            type="primary"
            size="small"
            @click="submitexportStudentObj('exportStudentObjForm')"
            >确定</el-button
          >
        </el-row>
      </footer>
    </el-dialog>
  </div>
</template>
<script>
import addStudent from './components/addStudent.vue'
import studentImport from './components/studentImport.vue'
import addParent from './components/addParent'
import updateStudent from './components/updateStudent'
import updateParent from './components/updateParent.vue'
import studentTransfer from './components/studentTransfer'

import datajson from './components/nation.json'

import {
  fileSever,
  studentList,
  deletdStudent,
  resetPassword,
  gradeClassList,
  studentUnbindParent,
  dexportStudent,
  urls,
  dictCode,
} from '@/api/home'

export default {
  components: {
    addStudent,
    studentImport,
    addParent,
    updateStudent,
    studentTransfer,
    updateParent,
  },
  data() {
    return {
      authSource: '',
      // 顶部搜索区域
      studentObj: {
        mobile: '', //手机号
        curPage: 1,
        pageSize: 20,
        gradeId: '', // 年级id
        classesId: '', // 班级id
        name: '', // 学生姓名
        rosterNo: '', // 学籍号
        active: '',
        totalCount: 0, //  studentTableList 总条数
      },
      schoolId: 0,
      token: '',
      roleType: localStorage.getItem('roleType'),
      studentTableList: [], // 表格数据列表
      multipleSelection: [], //选中学生列表
      dialogVisible: false, //导出学生 开关
      dialogAction: '',
      gradeList: [], // 年级列表
      classesList: [], // 班级列表
      // 导出学生
      classesLists: [], // 班级列表
      exportStudentObj: {
        schoolId: localStorage.getItem('schoolIds'),
        gradeId: '-1', // 年级
        classesId: '', // 班级
        studentTemplateType: 1, //类型
      },
      nationList: datajson.nationList, // 民族列表
      relationList: datajson.relationList, // 关系列表
      checkList: [], //选择框
      objClassesId: [],
      className: [], //班级名称
      classNames: '', //年级名称
      type: '',
      typeTime: '',
    }
  },
  created() {
    this.authSource = localStorage.getItem('authSource')
    this.schoolId = localStorage.getItem('schoolIds')
    this.exportStudentObj.schoolId = localStorage.getItem('schoolIds')
    this.token = localStorage.getItem('token')
    this.ApiStudentListPag()
    this.ApigradeGradelist()
    this.fileSever()
    this.type = localStorage.getItem('type')
    //  this.typeTime = setInterval(() => {
    //   this.type = localStorage.getItem('type')
    //   this.selectType()
    // }, 500);
  },
  methods: {
    //  selectType(){
    //   if (this.type !== null) {
    //     clearInterval(this.typeTime)
    //   }
    // },
    // 获取服务器地址
    async fileSever() {
      const { data: res } = await fileSever({
        schoolId: this.schoolId,
      })
    },

    // 获取学生列表
    ApiStudentListPag() {
      console.log(this.studentObj)
      studentList({
        schoolId: this.schoolId,
        ...this.studentObj,
      }).then((res) => {
        this.studentTableList = res.data.data.dataList
        // console.log(this.studentTableList)
        this.studentObj.totalCount = res.data.data.totalCount
      })
    },

    // 分页页码变化
    currentChange(e) {
      this.studentObj.curPage = e
      // 调用查询学生列表
      this.ApiStudentListPag()
    },

    handleSizeChange(val) {
      this.studentObj.curPage = 1
      this.studentObj.pageSize = val
      this.ApiStudentListPag()
    },

    // 获取年级列表
    ApigradeGradelist() {
      gradeClassList({
        schoolId: this.schoolId,
      }).then((res) => {
        this.classNames = res.data.data[0].name
        this.gradeList = res.data.data
        // this.exportStudentObj.gradeId = this.gradeList[0].gradeId
        // this.classesLists = this.gradeList[0].classesList
      })
    },
    // 导出学生
    changeclassesList(value) {
      this.studentObj.classesId = ''
      this.classesLists = []
      this.gradeList.map((item) => {
        if (item.gradeId == value) {
          this.classNames = item.name
          this.classesLists = item.classesList
        }
      })
      // this.classesList = value.classesList;
      this.checkList = []
    },
    // 查询学生
    changeclassesLists(value) {
      this.studentObj.classesId = ''
      this.classesList = []
      this.gradeList.map((item) => {
        if (item.gradeId == value) {
          this.classesList = item.classesList
        }
      })
      // this.classesList = value.classesList;
      this.checkList = []
    },

    // 搜索和重置功能
    searchList() {
      // this.studentObj.curPage = 1
      this.ApiStudentListPag()
    },
    searchLists() {
      this.studentObj.curPage = 1
      this.ApiStudentListPag()
      console.log('search')
    },

    // 删除学生
    DeleteStudentHandle(obj) {
      this.$confirm(
        `该操作将永久性删除 <span style="color:#409EFF;margin:0 10px;">${obj.student.name}</span>学生的数据！`,
        // `您确定要删除 <span style="color:#409EFF;margin:0 10px;">${obj.student.name}</span>学生么?`,
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          dangerouslyUseHTMLString: true,
        }
      )
        .then(() => {
          deletdStudent(obj.student.id).then((res) => {
            if (res.data.code == 0) {
              setTimeout(() => {
                this.$message({
                  type: 'success',
                  message: '删除成功',
                })
              }, 500)

              this.ApiStudentListPag()
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          })
        })
    },

    //重置密码
    ApiResetPass(roleType, obj) {
      console.log(obj)
      this.$confirm(
        `您确定要重置<span style="color:#409EFF;margin:0 10px;">${
          obj.student.name + ' '
        }${
          roleType == 'parent' ? '家长' : '学生'
        }</span>的密码么?重置后的密码是000000`,
        '重置密码',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          dangerouslyUseHTMLString: true,
        }
      )
        .then(() => {
          let data = {
            roleType,
            userId:
              roleType == 'parent' ? obj.parentList[0].id : obj.student.id,
          }
          resetPassword({ ...data }).then(() => {
            this.$message({
              type: 'success',
              message: '重置成功',
            })
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消重置',
          })
        })
    },

    // 选中 学生
    handleSelectionChange(val) {
      this.multipleSelection = val
    },

    // 禁用选择框
    CheckSelecttable(row, index) {
      return !!row.parentList.length
    },
    // 解除家长绑定
    async RemoveParent() {
      const confirResult = await this.$confirm('您确定要解除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).catch((err) => err)
      if (confirResult !== 'confirm') {
        return this.$message.info('已取消！！')
      }
      let ids = []
      if (!this.multipleSelection.length) {
        return this.$message.error('请选择需要解除家长绑定的学生')
      }
      this.multipleSelection.map((k) => {
        ids.push(k.student.id)
      })
      ids = ids.join(',')
      studentUnbindParent({
        ids: ids,
      }).then(() => {
        this.$message({
          type: 'success',
          message: '解除成功',
        })
        this.multipleSelection = []
        this.$refs.studentTable.clearSelection()
        this.ApiStudentListPag()
      })
    },
    // 一键导出 学生
    getApiExportStudentList() {
      this.dialogAction = '导出家校通讯录'
      this.dialogVisible = true
    },

    checkBox(id, name) {
      const idx = this.objClassesId.indexOf(id)
      if (idx !== -1) {
        this.objClassesId.splice(idx, 1)
      } else {
        this.objClassesId.push(id)
      }
      const nameIdx = this.className.indexOf(name)
      if (nameIdx !== -1) {
        this.className.splice(nameIdx, 1)
      } else {
        this.className.push(name)
      }
    },

    // 隐藏弹框
    async hidedialogVisible() {
      this.dialogVisible = false
      switch (this.dialogAction) {
        case '添加学生':
          this.resetForm('studentItemObjForm')
          break
        case '编辑学生信息':
          //     // this.$refs.studentItemObjForm.resetFields();
          this.resetForm('studentItemObjForm')
          break
        case '学生转入':
          //     // this.$refs.searchIntoObjForm.resetFields();
          this.resetForm('searchIntoObjForm')
          break
      }
      this.$nextTick()
      // this.$nextTick();
      this.exportStudentObj.gradeId = ''
      this.exportStudentObj.classesId = ''
      // this.ApigradeGradelist()
    },

    // 提交 导出学生 表单提交
    submitexportStudentObj(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.ApiExportStudentList()
          this.hidedialogVisible()
          this.ApiStudentListPag()
        } else {
          this.$message.error('请检查信息是否填写正确')
          return false
        }
      })
    },
    async ApiExportStudentList() {
      this.exportStudentObj.classesId = this.objClassesId.toString()
      let daoName = this.classNames + this.className.toString() + '学生列表'
      if (this.exportStudentObj.gradeId == -1) {
        this.exportStudentObj.gradeId = ''
        daoName = '全部学生列表'
      }
      const res = await dexportStudent(this.exportStudentObj, daoName)
      this.exportStudentObj.gradeId = this.gradeList[0].gradeId
      this.classNames = this.gradeList[0].name
      this.classesLists = this.gradeList[0].classesList
      this.objClassesId = []
      this.checkList = []
      this.className = []
    },
    //获取全部班级
    // async classListAll(){
    //   const {data:res} = await classListAll({

    //   })
    // }
  },
}
</script>
<style scoped>
.basisInformation {
  font-size: 16px;
  font-weight: 700;
}
.el-divider {
  margin-top: 18px;
  margin-bottom: 18px;
}
.el-checkbox-group {
  margin-left: 50px;
}
.el-table__body .el-button + .el-button {
  margin-left: 20px;
}
.left_btn {
  margin-left: 12px;
}
.text_btn {
  margin-left: 30px;
}
/* .el-form{
  margin-bottom: 8px;
} */
</style>



// WEBPACK FOOTER //
// src/views/school/components/Student.vue